import React from "react";
import Mainervices from "../../Main/Mainervices/Mainervices";

import Footer from "../../Shared/Footer/Footer";

import Banner from "../Banner/Banner";
import Service from "../Service/Service";
import Testimonial from "../Testimonial/Testimonial";

const Home = () => {
  return (
    <div id="home">
      <Banner></Banner>
      <Service></Service>
      <Mainervices></Mainervices>
      <Testimonial></Testimonial>
      <Footer></Footer>
    </div>
  );
};

export default Home;
